<template>
    <div>
         <g-card
            class="menu-dashboard"
            :paddingDefault="'0 px'"
            :temCabecalho="false"
            :sombreado="true"
        >
            <div class="items-menu-dashboard">

                <div v-for="item in itensMenu" :key="item.rota">
                    <div v-if="!item.subItens.length"
                        v-on:click="redirecionar(item.rota)"
                        :class="'item-pai' + ativo(item.rota)"
                    >{{item.titulo}}</div>


                    <VMenu
                        v-else
                        :class="'item-pai' + ativo(item.rota)"
                    >
                        <div>{{item.titulo}}</div>
                        <template #popper>
                            <div
                            class="container-itens-popper">
                                <PButton
                                            v-for="navBarSubItem in item.subItens"
                                            :key="navBarSubItem.rota"
                                            :class="`botoes ${ativo(navBarSubItem.rota)}`"
                                            v-on:click="redirecionar(navBarSubItem.rota)">{{navBarSubItem.titulo}}

                                </PButton>
                            </div>
                        </template>
                    </VMenu>
                </div>
            </div>
        </g-card>

    </div>
</template>

<script>
import GNavbar from './g-navbar.js'
export default GNavbar
</script>

<style scoped>
.botoes{
    width: 50%;
    color: #A8A8A8;
    background: white;
    border-color: white;
    box-shadow: none;
}
.menu-dashboard{
    margin: 0 auto;
    width: 100%;
    height: 100%;
    min-height: 0;
    display: v-bind('display');
}

.items-menu-dashboard{
    display: flex;
    justify-content: space-around;
    align-items: center;
    height: 100%;
}
.items-menu-dashboard div:hover {
    cursor: pointer;
}

.item-pai{
    color: #A8A8A8;
    padding: 1em;
    font-family: "MontSerrat";
}

.item-pai:hover{
    color: #4F2C19;
    font-weight: bold;
    font-family: "MontSerrat";
    padding: 1em;
}

.item-paiativo{
    color: #4F2C19;
    font-weight: bold;
    font-family: "MontSerrat";
    padding: 1em;
    border-top: 3px #FCB315 solid;
}

.botoes.ativo{
    border: 10px;
    color: #4F2C19;
    text-decoration: underline;
    font-family: "MontSerrat";
    font-weight: bold;
    outline: 0;
}
.p-button:focus {
    outline: 0 ;
    outline-offset: 0;
    box-shadow: none;
}

.botoes.p-button{
    display: block;
    padding: 0.125rem;
    font-family: "MontSerrat";
    text-align: left;
    font-style: bold;
    width: auto;
}

.p-button:enabled:hover {
    color: #4F2C19;
    background: white;
    font-family: "MontSerrat";
    border-color: white;
    box-shadow: none;
}

.container-itens-popper{
    width: 100%;
    max-width: 500px;
    padding: 15px 10px;
    /* display: flex;
    flex-direction: row;
    flex-wrap: wrap; */

    /* display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: auto; */
}

</style>

